// Library Import
import {
  Avatar,
  Box,
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Flex,
  Icon,
  IconButton,
  useDisclosure,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

// Icon Imports
import { FaBell } from "react-icons/fa";
import { FiMenu } from "react-icons/fi";

// Local Imports
import Sidebar from "../../components/admin/Sidebar";
import Addtask from "../../components/admin/Addtask";
import Edittask from "../../components/admin/Edittask";
import CCLOGOINI from "../../assets/CCLOGOINI.png";
import DeleteUser from "../../components/admin/DeleteUser";
import ExcelUpload from "../../components/admin/ExcelUpload";

const AdminDashboard = () => {
  const sidebar = useDisclosure();
  const navigate = useNavigate();

  const [screenType, setScreenType] = useState("excelUploadUser");

  const { adminLoggedIn } = useSelector((state) => state.stateAdminReducer);

  useEffect(() => {
    if (!adminLoggedIn) {
      navigate("/admin");
    }
  }, [adminLoggedIn]);

  return (
    <Box as="section" bg="gray.50" minH="100vh">
      <Sidebar
        display={{ base: "none", md: "unset" }}
        setScreenType={setScreenType}
      />

      {/* Mobile Sidebar */}
      <Drawer
        isOpen={sidebar.isOpen}
        onClose={sidebar.onClose}
        placement="left"
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <Sidebar
            w="100%"
            marginTop="30px"
            borderRight="none"
            setScreenType={setScreenType}
          />
        </DrawerContent>
      </Drawer>

      <Box ml={{ base: 0, md: 60 }} transition=".3s ease">
        <Flex
          as="header"
          align="center"
          justify="space-between"
          w="full"
          px="4"
          bg="white"
          borderBottomWidth="1px"
          color="inherit"
          h="14"
        >
          {/* Mobile Sidebar Menu Button */}
          <IconButton
            aria-label="Menu"
            display={{ base: "inline-flex", md: "none" }}
            onClick={sidebar.onOpen}
            icon={<FiMenu />}
            size="sm"
          />

          <Flex align="center" pos="absolute" right="30px">
            <Icon color="gray.500" as={FaBell} cursor="pointer" />
            <Avatar
              ml="4"
              size="sm"
              name="anubra266"
              src={CCLOGOINI}
              cursor="pointer"
            />
          </Flex>
        </Flex>

        <Flex w="100%" h="92vh">
          {/* Home Screen */}
          {screenType === "home" && (
            <Box as="main" p="4" w="100%" h="100%">
              {/* Add content here, remove div below  */}
              <Box borderWidth="4px" borderStyle="dashed" rounded="md" h="96" />
            </Box>
          )}

          {/* Add Task Screen */}
          {screenType === "addTask" && <Addtask />}

          {/* Delete Task Screen */}
          {screenType === "EditTask" && <Edittask />}

          {/* Delete User Screen */}
          {screenType === "deleteUser" && <DeleteUser />}

          {/* Delete User Screen */}
          {screenType === "excelUploadUser" && <ExcelUpload />}
        </Flex>
      </Box>
    </Box>
  );
};
export default AdminDashboard;
